import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  { name: 'Free Flow Salt', image: '/images/salt/freeflow.webp', link: '/salts/freeflow' },
  { name: 'Crystal Salts', image: '/images/salt/crystal.webp', link: '/salts/crystal' },
  { name: 'Pink Salt (Crystal)', image: '/images/salt/pink.webp', link: '/salts/pink' }
];

const typeOptions = ['Packet', 'Jar'];
const qtyOptions = ['500g', '1kg', '5kg', '10kg', '25kg'];

const Salt = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [selectedTypes, setSelectedTypes] = useState({});
  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };

  const goToProducts = () => {
    navigate('/products');
  };

  const toggleType = (index, type) => {
    setSelectedTypes({
      ...selectedTypes,
      [index]: selectedTypes[index] === type ? null : type,
    });
  };

  const toggleQtyType = (index, qtyType) => {
    const selectedType = selectedTypes[index];
    if (!selectedType) {
      toast.warn("Please select Packet or Jar first!", { position: "top-right" });
      return;
    }

    const productQuantities = selectedQuantities[index]?.[selectedType] || {};
    const isSelected = qtyType in productQuantities;

    const updated = { ...productQuantities };
    if (isSelected) {
      delete updated[qtyType];
    } else {
      updated[qtyType] = 1;
    }

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...(selectedQuantities[index] || {}),
        [selectedType]: updated,
      },
    });
  };

  const incrementQty = (index, qtyType) => {
    const type = selectedTypes[index];
    const productQuantities = selectedQuantities[index]?.[type] || {};
    const currentQty = productQuantities[qtyType] || 1;

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...(selectedQuantities[index] || {}),
        [type]: {
          ...productQuantities,
          [qtyType]: currentQty + 1,
        },
      },
    });
  };

  const decrementQty = (index, qtyType) => {
    const type = selectedTypes[index];
    const productQuantities = selectedQuantities[index]?.[type] || {};
    const currentQty = productQuantities[qtyType];

    if (currentQty > 1) {
      setSelectedQuantities({
        ...selectedQuantities,
        [index]: {
          ...(selectedQuantities[index] || {}),
          [type]: {
            ...productQuantities,
            [qtyType]: currentQty - 1,
          },
        },
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const type = selectedTypes[index];
    const quantities = selectedQuantities[index]?.[type];

    if (!type || !quantities || Object.keys(quantities).length === 0) {
      toast.warn("Please select Packet/Jar and at least one quantity!", { position: "top-right" });
      return;
    }

    Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
      const item = {
        ...product,
        qtyType,
        qtyCount,
        packagingType: type,
      };
      addToCart(item);
      toast.success(`${product.name} (${qtyCount} × ${qtyType}) [${type}] added to cart`, {
        position: "top-right",
        autoClose: 2000,
      });
    });
  };

  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Salt Products</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>

            <div className="type-options">
              {typeOptions.map((type) => (
                <span
                  key={type}
                  className={`type ${selectedTypes[index] === type ? 'selected' : ''}`}
                  onClick={() => toggleType(index, type)}
                >
                  {type}
                </span>
              ))}
            </div>

            {selectedTypes[index] && (
              <div className="qty-options">
                {(selectedTypes[index] === 'Jar' ? ['500g', '1kg'] : qtyOptions).map((qtyType) => {
                  const isSelected = selectedQuantities[index]?.[selectedTypes[index]]?.[qtyType];

                  return (
                    <div key={qtyType} className="qty-select-block">
                      <span
                        className={isSelected ? 'qty selected' : 'qty'}
                        onClick={() => toggleQtyType(index, qtyType)}
                      >
                        {qtyType}
                      </span>
                      {isSelected && (
                        <div className="qty-controls">
                          <button onClick={() => decrementQty(index, qtyType)}>-</button>
                          <span>{selectedQuantities[index][selectedTypes[index]][qtyType]}</span>
                          <button onClick={() => incrementQty(index, qtyType)}>+</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />
    </section>
  );
};

export default Salt;
